<script>
    import Price from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Price.svelte?1733898724847';
    import Qty from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Qty.svelte?1733898724847';
    import Image from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Image.svelte?1733898724847';
    import { get_image_path } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/get_image_path.js?1733898724847';
    import { update_qty_delayed } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/cart/minicart/item_events.js?1733898724847';
    import { get_store } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/api-client/get_store.js?1733898724847';
    import { url_join } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/url.js?1733898724847';
    import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724847';
    import Spinner from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Spinner.svelte?1733898724847';
    import { logger } from '@wyvr/generator/universal.js';

    export let item;
    export let locale;
    export let currency;

    let state = 'idle';

    const slug = "p";

    $: image_path = item.thumbnail ? get_image_path(item.thumbnail) : undefined;
    $: link = url_join(get_store(), slug, get_attribute_value(item, 'url_key'));
    $: brand = get_brand(item);

    function update_qty_event(e) {
        update_qty_delayed(
            item.sku,
            e.detail?.qty,
            () => {
                state = 'busy';
            },
            () => {
                state = 'idle';
            }
        );
    }

    function get_brand(item) {
        if (!item || !item.pim_brand) {
            return undefined;
        }
        if (typeof item.pim_brand === 'object' && item.pim_brand.name) {
            return item.pim_brand.name;
        }
        let data = undefined;
        try {
            data = JSON.parse(item.pim_brand);
            return data?.name;
        } catch (e) {
            logger.error(e);
            return undefined;
        }
    }
</script>

<div class="item">
    {#if image_path}
        <a class="product-img" href={link}>
            <Image src={image_path} alt={item.name} width={75} height={75} mode={'contain'} />
        </a>
    {/if}
    <div class="details">
        {#if brand}
            <a class="brand" href={link}>
                {brand}
            </a>
        {/if}
        <a class="product-name" href={link}><b>{@html item.name}</b></a>
        <div class="price__quantity">
            <div class="price">
                <span class="price-label">{window.__('cart.price')}</span>
                <Price product={item} {locale} {currency} force_price_display={true} />
            </div>
            {#if state == 'idle'}
                <Qty qty={item.qty} on:update={update_qty_event} />
            {:else}
                <Spinner />
            {/if}
        </div>
    </div>
</div>


<style>
    .item {
        border-top: 1px solid #e8dcca;
        padding: 0.5rem 0;
        display: flex;
        gap: 1rem;
        margin-bottom: 0.5rem;

        @media (min-width: 1440px) {
            padding: 1rem 0;
            margin-bottom: 1rem;
        }
    }

    .item:first-child {
        border-top: none !important;
    }

    .brand {
        color: var(--lightgray);
        font-size: var(--font-size__s);
        font-weight: var(--font-weight__regular);
        line-height: var(--line-height__base);
        text-decoration: none;
    }

    .details {
        flex-grow: 1;
    }

    .details .product-name {
        line-height: 1;
        text-decoration: none;
    }

    .details .product-name b {
        font-weight: var(--font-weight__semibold);
    }

    .price-label {
        text-transform: none !important;
        font-weight: var(--font-weight__semibold);
    }

    .price > span {
        font-size: var(--font-size__xs);
    }

    .price > :global(div) {
        display: flex !important;
        flex-direction: column-reverse;
        align-items: start !important;
    }

    .price > :global(div .regular_price_text) {
        margin: 0 !important;
        font-size: var(--font-size__xs) !important;
    }

    .price > :global(div .regular_price_text .regular_price) {
        display: inline-block !important;
        font-size: var(--font-size__xs) !important;
    }

    .price > :global(div .price.spezial) {
        font-size: 1.125rem !important;
    }

    .price__quantity {
        display: flex;
        padding-top: 10px;
        justify-content: space-between;
        align-items: center;
    }

    .price__quantity > :global(div:nth-child(2)) {
        display: flex !important;
    }

    .details > :nth-child(2) {
        display: block !important;
    }

    .price__quantity > :global(div:nth-child(2) div) {
        display: block !important;
    }

    .price__quantity :global(.base) {
        margin-top: 0 !important;
    }
</style>